import ApprovalConfirmBoxPageVue from '@/pages/approval/ApprovalConfirmBoxPage.vue';
import ApprovalDetailPageVue from '@/pages/approval/ApprovalDetailPage.vue';
import ApprovalPageVue from '@/pages/approval/ApprovalPage.vue';
import ApprovalPendingBoxPageVue from '@/pages/approval/ApprovalPendingBoxPage.vue';
import ApprovalRequestBoxPageVue from '@/pages/approval/ApprovalRequestBoxPage.vue';
import ApprovalRequestDetailPageVue from '@/pages/approval/ApprovalRequestDetailPage.vue';
import ApprovalRequestPageVue from '@/pages/approval/ApprovalRequestPage.vue';
import AttendanceActivitiesPageVue from '@/pages/attendance/AttendanceActivitiesPage.vue';
import AttendanceMonthPageVue from '@/pages/attendance/AttendanceMonthPage.vue';
import AttendanceDayPageVue from '@/pages/attendance/AttendanceDayPage.vue';
import AttendanceDayViewPageVue from '@/pages/attendance/AttendanceDayViewPage.vue';
import HomePageVue from '@/pages/HomePage.vue';
import LoginPageVue from '@/pages/LoginPage.vue';
import NotFoundPageVue from '@/pages/NotFoundPage.vue';
import { useAuthStore } from '@/stores/auth.ts';
import { createRouter, createWebHistory } from 'vue-router';
import UnauthorizedPage from '@/pages/UnauthorizedPage.vue';
import SearchPage from '@/pages/search/SearchPage.vue';

export const ROUTES = {
  Home: 'Home',
  Login: 'Login',
  AttendanceRoot: 'AttendanceRoot',
  ApprovalRoot: 'ApprovalRoot',
  SearchRoot: 'SearchRoot',
} as const;

export type RouteNames = keyof typeof ROUTES;

export const router = createRouter({
  history: createWebHistory(),
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
  routes: [
    {
      // WELCOME
      path: '/',
      name: ROUTES.Home,
      component: HomePageVue,
      meta: { role: 'ORIGIN' },
    },
    {
      path: '/login',
      name: ROUTES.Login,
      component: LoginPageVue,
    },
    {
      path: '/unauthorized',
      name: 'unauthorized',
      component: UnauthorizedPage,
    },
    {
      // 근태현황
      path: '/attendance',
      name: ROUTES.AttendanceRoot,
      meta: { role: 'ORIGIN' },
      children: [
        {
          path: '',
          name: 'AttendanceMonth',
          component: AttendanceMonthPageVue,
          meta: {
            role: 'ORIGIN',
          },
        },
        {
          path: 'day/:targetDate',
          name: 'AttendanceDay',
          component: AttendanceDayPageVue,
          props: true,
          meta: {
            role: 'ORIGIN',
          },
        },
        {
          path: 'day/view/:empNo/:targetDate',
          name: 'AttendanceDayView',
          component: AttendanceDayViewPageVue,
          props: true,
          meta: {
            role: 'ORIGIN',
          },
        },
        {
          path: 'activities/:attendanceId/:targetDate',
          name: 'AttendanceActivities',
          component: AttendanceActivitiesPageVue,
          props: true,
          meta: {
            role: 'ORIGIN',
          },
        },
      ],
    },
    {
      // 결재함
      path: '/approval',
      name: ROUTES.ApprovalRoot,
      meta: {
        role: 'ORIGIN_OR_MANAGER',
      },
      children: [
        {
          path: '',
          name: 'Approval',
          component: ApprovalPageVue,
        },
        {
          path: 'request',
          name: 'ApprovalRequest', // 신청서 작성
          component: ApprovalRequestPageVue,
          props: (route) => ({ query: route.query }),
          meta: {
            role: 'ORIGIN',
          },
        },
        {
          path: 'box/request',
          name: 'ApprovalRequestBox', // 나의 신청 목록
          component: ApprovalRequestBoxPageVue,
          meta: {
            role: 'ORIGIN',
          },
        },
        {
          path: 'box/request/detail/:id',
          name: 'ApprovalRequestDetail',
          component: ApprovalRequestDetailPageVue,
          props: true,
          meta: {
            role: 'ORIGIN',
          },
        },
        {
          path: 'box/pending',
          name: 'ApprovalPendingBox', // 승인할 목록
          component: ApprovalPendingBoxPageVue,
          meta: {
            role: 'MANAGER',
          },
        },
        {
          path: 'box/pending/detail/:id',
          name: 'ApprovalPendingDetail',
          component: ApprovalDetailPageVue,
          props: true,
          meta: {
            role: 'MANAGER',
          },
        },
        {
          path: 'box/confirm',
          name: 'ApprovalConfirmBox', // 완료 목록
          component: ApprovalConfirmBoxPageVue,
          meta: {
            role: 'MANAGER',
          },
        },
        {
          path: 'box/confirm/detail/:id',
          name: 'ApprovalConfirmDetail',
          component: ApprovalDetailPageVue,
          props: true,
          meta: {
            role: 'MANAGER',
          },
        },
      ],
    },
    {
      // 조회
      path: '/search',
      name: ROUTES.SearchRoot,
      children: [
        {
          path: '',
          name: 'Search',
          component: SearchPage,
          meta: {
            role: 'ORIGIN_OR_MANAGER',
          },
        },
      ],
    },
    {
      // 404
      path: '/:path(.*)*',
      name: 'NotFound',
      component: NotFoundPageVue,
    },
  ],
});

router.beforeEach((to /* , from */) => {
  const auth = useAuthStore();

  if (to.meta.role) {
    if (!auth.isLoggedIn) {
      localStorage.setItem('redirect', to.fullPath);
      return {
        path: '/login',
      };
    }

    if (to.meta.role == 'ORIGIN' && !auth.isOrigin) {
      if (auth.isManager) {
        return {
          path: '/approval',
        };
      }
    }
  }
});
